export * from './TooltipContentForMultipleValues';
